import { colors, fontWeights, spacing } from '@cabonline/ui-shared';
import styled from '@emotion/styled';
import { CSVLink } from 'react-csv';

export const StyledCsvModalContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  width: auto;
  p:first-of-type {
    margin-bottom: 1rem;
  }
  p {
    font-weight: ${fontWeights.semi};
    color: ${colors.gray1};
    line-height: 1.5;
  }
`;

export const StyledTableWrapper = styled.table`
  width: 500px;
  margin-bottom: ${spacing.xl};
`;

export const StyledTableBody = styled.tbody``;

export const StyledCsvLink = styled(CSVLink)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  text-decoration: none;
`;

export const StyledCsvFileTableRow = styled.tr`
  & :first-of-type {
    font-weight: ${fontWeights.bold};
  }
  & :nth-of-type(2) {
    font-weight: normal;
    color: ${colors.gray1};
  }
`;

export const StyledSuccessWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing.m};
  padding: ${spacing.xl} 0;
  color: ${colors.primary};

  p {
    font-weight: ${fontWeights.semi};
    color: ${colors.gray1};
  }
`;
